/** Runtime tunables: durations, ratios, and numeric caps (DR-3). Values from git HEAD. */

export const PANEL_MIN_RATIO = 0.2;
export const PANEL_MAX_RATIO = 0.5;

export const RUN_STATE_DEBOUNCE_MS = 400;
export const AWARENESS_VIEWPORT_DEBOUNCE_MS = 500;
export const AWARENESS_INTENT_DEBOUNCE_MS = 300;

export const INSTRUCTION_TTL_MS = 5000;
export const INSTRUCTION_QUEUE_POLL_MS = 100;

export const SSE_RECONNECT_BASE_MS = 1000;
export const SSE_RECONNECT_MAX_MS = 30000;

/** Subscriber toast auto-close (useToastSubscriber). */
export const TOAST_AUTO_CLOSE_MS = 4000;

/** HIL success toast auto-close (showHilRaisedToast). */
export const HIL_TOAST_AUTO_CLOSE_MS = 15_000;

/** react-toastify container for bottom-right HIL success toasts. */
export const HIL_TOAST_CONTAINER_ID = 'hil-success-toasts';

export const MAX_ESA_THREADS = 100;
export const MAX_ESA_NOTIFICATIONS = 100;
export const HIL_INBOX_FETCH_LIMIT = 50;

export const BULK_UPLOAD_POLL_INTERVAL_MS = 2000;
export const BULK_UPLOAD_POLL_MAX_ATTEMPTS = 60;

export const PKS_FETCH_TIMEOUT_MS = 5000;

/** Layout ToastContainer auto-close — distinct from subscriber toast (AR1-006). */
export const TOAST_CONTAINER_AUTO_CLOSE_MS = 2000;

export const INBOX_UNREAD_CLEAR_MS = 3000;
export const CANVAS_MAX_DEPTH = 3;
export const ESA_THREAD_PAGE_SIZE = 20;
export const INBOX_FETCH_LIMIT = 15;
export const ESA_CANVAS_DIVIDER_WIDTH = 6;

export const MAX_SELECTED_ROWS = 200;
export const MAX_DATA_RESPONSE_ROWS = 50;
